export default {
    mounted(el, binding) {
      el.addEventListener('input', () => {
        const value = el.value;
  
        const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!_"@*?()\-=+&^%$])[A-Za-z\d!_"@*?()\-=+&^%$]{8,20}$/;
  
        const isValid = regex.test(value);
        
        if (value.length >= 8 && value.length <= 10) {
          el.style.borderColor = 'orange'; 
        } else if (value.length > 10 && value.length <= 20) {
          el.style.borderColor = 'green';
        } else {
          el.style.borderColor = 'red'; 
        }
        if (binding.value) {
          binding.value(isValid);
        }
        if (!value) {
          el.style.borderColor = '';
        }
      });
    }
  };